import { useConfigProperty, type LeagueConfig } from '@leagueplatform/core';

const defaultConfig = {
  showFullTimeStamp: false,
  labs: undefined,
} satisfies NonNullable<LeagueConfig['dashboard']>;

export const useDashboardConfig = () =>
  useConfigProperty('dashboard', defaultConfig);
